var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "" } },
    [
      _c(
        "v-flex",
        {
          staticClass: "setBgHeader widthfull",
          style: { background: _vm.backgroudHeader },
          attrs: { xs12: "" }
        },
        [
          _c(
            "h3",
            { staticClass: "centerDiv mt-1", staticStyle: { color: "white" } },
            [_vm._v("แชทกับเรา")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { staticClass: "headername widthfull", attrs: { xs12: "" } },
        [
          _c("v-avatar", { staticClass: "f-l mr-2 user-photoprofilechat" }, [
            _c("img", {
              staticClass: "alligator-turtle",
              attrs: { src: "/static/img/call-center.png", alt: "John" }
            })
          ]),
          _vm._v(" "),
          _c(
            "v-layout",
            {
              staticStyle: { "padding-top": "12px" },
              attrs: { row: "", wrap: "", "align-center": "" }
            },
            [
              _c("h4", { staticStyle: { "margin-left": "1vw" } }, [
                _vm._v("จบการสนทนา")
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.tokenservice !== undefined && _vm.tokenservice !== null
        ? _c(
            "v-flex",
            {
              staticClass: "setHeightChatBoxrating",
              staticStyle: { "text-align": "center", background: "white" },
              attrs: { xs12: "" }
            },
            [
              _c("br"),
              _vm._v(" "),
              _c("h3", [_vm._v("ขอบคุณที่ใช้บริการค่ะ")]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  style: { background: _vm.backgroudHeader },
                  attrs: { loading: _vm.loading, dark: "", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.startchat()
                    }
                  }
                },
                [_vm._v("เริ่มสนทนาใหม่")]
              )
            ],
            1
          )
        : _c(
            "v-flex",
            {
              staticClass: "setHeightChatBoxrating",
              staticStyle: { "text-align": "center", background: "white" },
              attrs: { xs12: "" }
            },
            [
              _c(
                "v-layout",
                {
                  staticStyle: { "margin-top": "200px" },
                  attrs: {
                    "align-center": "",
                    "justify-center": "",
                    column: ""
                  }
                },
                [_c("h2", [_vm._v("ขอบคุณที่ใช้บริการค่ะ")])]
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06f794c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06f794c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Endchatpage.vue
// module id = null
// module chunks = 